export default __webpack_public_path__ + "static/media/OasisLandBG12.b2c9950b.webp";